<script>
import Layout from "../../../router/layouts/print";

/**
 * Screen component
 */
/* eslint-disable no-console */

export default {
  components: { Layout },
  data() {
    // alert(data)
    return {
      contract: null,
      saleDates: [],
      doDate: [],
      doYear: [],
      partners : "",
      partner_names : "",
    };
   
  },
  mounted() { },

  watch: {
    data: function(newVal) { 
      this.contract = newVal;
      this.saleDates = this.contract.sale_date.split("-");
      this.doDate = this.contract.cancel_date.split("-");
      this.doYear = this.contract.do_year;

      // console.log(JSON.stringify(this.contract));
      this.contract.customer_partners.map((item) => {
        this.partners += `/ ${item.partner_name}`;
        this.partner_names += ` និងឈ្មោះ <a class="khm dblack">${item.partner_name}<a/>  ភេទ: ${item.partner_sex}`;
      });
    },
  },

  methods: {

    formatCurrency(value, sign = '$', decimal = '.00') {
      return  sign.length > 1 ? sign + this.$options.filters.numFormat(value, `0,0${decimal}`) : this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);
    }

  },

  props: {
    data: null,
  }

};
</script>
<template>
  <Layout>
        <center>

          <div class="col dblack box-a4-long kh">
            <p class="khm title l3" style="margin-top: 0.2cm;">ព្រះរាជាណាចក្រកម្ពុជា</p>
            <p class="khm h5 l4">ជាតិ សាសនា ព្រះមហាក្សត្រ</p>
            <p class="top-0">
              <img src="../../../assets/images/3symbol.svg" style="width: 150px;"/>
            </p>
            <p class="khm sub-title top3"><u>លិខិតបញ្ជាក់ស្តីពីការបោះបង់សិទ្ធិ</u><br/><br/>
            <u>និងការរំលាយកិច្ចព្រមព្រៀងលក់-ទិញលំនៅឋាន</u></p>
            <!-- <p class="en sub-title" style="margin-top: -20px; font-size: 12pt;">~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~</p> -->
  
            <table width="100%" class="doc-content top text-justify" style="">
              <tr>
                <td width="16%"><p>&nbsp;</p></td>
                <td width="84%"><p>&nbsp;</p></td>
              </tr>
              <tr>
                <td>
                  <p class="kh"><u>យោង:</u></p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    កិច្ចព្រមព្រៀងលក់-ទិញលំនៅឋានលេខៈ <span class="number">{{this.contract && this.contract.sale_code}} </span> <b class="dblack">ចុះថ្ងៃទី {{this.saleDates[0]}} ខែ {{saleDates[1]}} ឆ្នាំ {{saleDates[2]}}</b>
                    រវាង <span class="khm dblack">ក្រុមហ៊ុនលំនៅឋាន អេចស៊ី ឯ.ក</span> តំណាងដោយលោក <span class="khm dblack">លឹម ទ្រី</span> (ភាគី “ក” ឬភាគីអ្នកលក់) <span class="khm dblack">ជាមួយនឹង</span> ឈ្មោះ <span class="khm dblack">{{this.contract && this.contract.customer_name}}</span> ភេទ: {{this.contract && this.contract.sex}} 
                    <span v-html="partner_names" id="app">
        </span>
                     (ភាគី “ខ” ឬភាគីអ្នកទិញ)។
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="kh mt-3"><u>ដោយហេតុថា:</u></p>
                </td>
                <td>
                  <p style="text-align: justify;" class="mt-3">
                    - ភាគី “ខ” បាទទិញយូនីតខុនដូលេខៈ {{this.contract && this.contract.property_code}} ជាន់ទី {{this.contract && this.contract.property_code.split('-')[1]}} 
                    ដែលមានទីតាំងស្ថិតនៅដីឡូតិ៍លេខៈ 1255 ផ្លូវលេខៈ 1978 ភូមិទំនុប សង្កាត់ភ្នំពេញថ្មី ខណ្ឌសែនសុខ រាជធានីភ្នំពេញ ។ 
                    <span class="kh bold">ក្នុងតម្លៃ {{this.contract && formatCurrency(this.contract.sale_price)}}</span> ({{this.contract && this.contract.sale_price_kh}})
                    ហើយមិនមានលទ្ធភាពបង់ប្រាក់បន្តជូនភាគី “ក” ។ 
                    ដូច្នេះភាគី “ខ” បានសម្រេចចិត្តបោះបង់យូនីតខុនដូលេខៈ {{this.contract && this.contract.property_code}} ជាន់ទី {{this.contract && this.contract.property_code.split('-')[1]}}  <span class="kh">(ឈប់ទិញ) ។</span>
                  </p>
                  <p style="text-align: justify;" class="mt-3">
                    - ភាគី “ក” បានពិនិត្យឃើញថា ភាគី “ខ” ពិតជាពុំមានលទ្ធភាពបង់ប្រាក់បន្ត និងមានចេតនាបោះបង់ចោល យូនីតខុនដូនេះពិតប្រាកដមែន 
                    ដូច្នេះភាគី “ខ” បានឯកភាពយល់ព្រម 
                    ហើយភាគីទាំងពីរ បានសម្រេចរំលាយ កិច្ចព្រមព្រៀងលក់-ទិញលំនៅឋានលេខៈ <span class="number">{{this.contract && this.contract.sale_code}} </span> ចុះថ្ងៃទី {{this.saleDates[0]}} ខែ {{saleDates[1]}} ឆ្នាំ {{saleDates[2]}} ចោលចាប់ពីថ្ងៃនេះតទៅ ។
                  </p>
                </td>
              </tr>
            </table>
            <table width="100%" class="doc-content top text-justify">
              <tr>
                <td width="10%"></td>
                <td>
                  <p style="text-align: justify;" class="mt-3 doc-content">
                    ផ្អែកតាមខដែលបានចែងក្នុងកិច្ចព្រមព្រៀងលក់-ទិញលំនៅឋានលេខៈ 
                    <span class="number">{{this.contract && this.contract.sale_code}} </span> 
                      ចុះថ្ងៃទី{{saleDates[0]}} ខែ {{saleDates[1]}} ឆ្នាំ {{saleDates[2]}} 
                  </p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>ត្រង់ប្រការ 3 ចំណុច 3.2 បានចែងថា៖ 
                    ក្នុងករណី ភាគី “ខ” យឺតយ៉ាវបង់ប្រាក់ជូន ភាគី “ក” លើសពី៣ថ្ងៃ ភាគី “ខ” យល់ព្រមបង់ប្រាក់ពិន័យជូន ភាគី “ក”
                    ចំនួនៈ0.5%(សូន្យចុចប្រាំភាគរយ)ក្នុង1ថ្ងៃនៃចំនួនទឹកប្រាក់ដែលត្រូវបង់ការយឺតយ៉ាវនេះមិនឱ្យលើសរយៈពេល60ថ្ងៃឡើយគិតពីថ្ងៃដែលបានខកខានបង់ប្រាក់។ 
                    បើហួសរយៈពេលនេះ ភាគី “ខ” នៅតែមិនបានបង់ប្រាក់តាមពេលវេលានិងគ្រប់ចំនួនតាមកាលវិភាគបង់ប្រាក់ដូចបានកំណត់ក្នុងកិច្ចព្រមព្រៀងនេះឬឈប់ទិញខុនដូនេះវិញ 
                    ប្រាក់ដែលបានបង់កន្លងមកនឹងបានជាប្រយោជន៏របស់ ភាគី “ក” ។ ភាគី “ក” នឹងមិនប្រគល់ប្រាក់ដែលបានបង់កន្លងមកជូនភាគី “ខ” វិញឡើយ។</p>
                </td>
              </tr>
            </table>
           
            <table width="60%" class="doc-content top text-justify mt-3">
              <tr style="border-bottom: 1px solid">
                <td width="60%">
                  <p class="kh" style="font-size: 16px">ចំនួន ទឹកប្រាក់ដើមបានបង់កន្លងមក <span class="kh number" style="float: right">:</span></p> 
                <td>
                  <p class="kh number" style="float: right">{{this.contract && formatCurrency(this.contract.paid_amount)}}</p>
                </td>
              </tr>
              <tr style="border-bottom: 1px solid">
                <td>
                  <p class="kh" style="font-size: 16px; font-weight: bolder !important">ចំនួន ទឹកប្រាក់ត្រូវបង្វែរជូនភាគី “ខ” វិញ <span class="kh number" style="float: right">:</span></p>
                </td>
                <td>
                  <p class="kh number" style="float: right"> {{this.contract && formatCurrency(this.contract.refund_amount)}}</p>
                </td>
              </tr>
            </table>
            <br/>
             <table width="100%" class="doc-content top text-justify mt-3">
              <tr>
                <td width="30%">
                  <br><br><br>
                  <p><center>ថ្ងៃទី..... ខែ...... ឆ្នាំ {{this.doYear}}</center></p>
                  <p><center>បានឃើញ និងឯកភាព</center></p>
                  <p class="khm"><center>ស្នាមមេដៃ ភាគី “ក”</center></p>
                  <br><br><br><br>
                  <p class="khm"><center> <span style="font-weight:900">លឹម ទ្រី</span> </center></p>

                </td>
                <td width="30%">
                  <br><br><br><br/>
                  <p><center>បានឃើញ និងឯកភាព</center></p>
                  <p class="khm"><center>ប្រធានគ្រប់គ្រងទូទៅ</center></p>
                  <br><br><br><br>
                  <p class="khm"><center> <span style="font-weight:900"></span> </center></p>
                </td>
                <td width="40%" >
                 
                    <p><center>រាជធានីភ្នំពេញ ថ្ងៃទី {{this.doDate[0]}} ខែ{{this.doDate[1]}} ឆ្នាំ {{this.doDate[2]}}</center></p>
                    <p class="khm"><center>ស្នាមមេដៃ ភាគី “ខ”</center></p>
                    <br><br><br><br>
                    <p class="khm"><center>{{this.contract && this.contract.customer_name}} {{this.partners}}</center></p>
                </td>
              </tr>
            </table>
          </div>
        </center>
  </Layout>
</template>